import React from "react";
import Layout from "../../components/layout";
import HeaderTwo from "../../components/header/header-two";
import StickyHeader from "../../components/header/sticky-header";
import Footer from "../../components/footer";
import ContactCard from "../../components/contact/contact-card-carousel"
import PartnerForm from "../../components/contact/partner-contact-form"

const HomeTwo = () => {
  return (
    <Layout pageTitle="Made You Love Tennis Foundation | Partner">
      <HeaderTwo />
      <StickyHeader extraClassName="stricky-header-two" />
      <PartnerForm />
      <ContactCard />
      <Footer />
    </Layout>
  );
};

export default HomeTwo;
